export const isFuture = (date) => date > Date.now()/1000